import { getHeroLede } from '../../lib/heroLede'
import type { PantryState } from '../../lib/welcomeLine'

type Props = {
  state:        PantryState
  onReviewList: () => void
  onPlanMeals:  () => void
}

function HeadlineWithItalic({ headline, italic }: { headline: string; italic: string }) {
  if (!italic || !headline.includes(italic)) {
    return <>{headline}</>
  }
  const idx    = headline.indexOf(italic)
  const before = headline.slice(0, idx)
  const after  = headline.slice(idx + italic.length)
  return (
    <>
      {before}
      <em className="italic" style={{ color: 'var(--sand)' }}>{italic}</em>
      {after}
    </>
  )
}

export function HomeHero({ state, onReviewList, onPlanMeals }: Props) {
  const { eyebrow, headline, italic, tone } = getHeroLede(state)
  const showPlanMeals  = tone !== 'calm' && tone !== 'empty'
  const primaryLabel   = tone === 'empty' ? 'Add first item' : 'Review list'

  return (
    <section className="relative mx-4 mb-[14px] overflow-hidden rounded-[20px] px-5 py-[22px]"
      style={{ background: 'var(--forest)', color: 'var(--forest-ink)' }}
    >
      {/* Decorative accent */}
      <div
        aria-hidden
        className="pointer-events-none absolute -right-10 -top-10 h-[140px] w-[140px] rounded-full"
        style={{ background: 'rgba(212,165,116,0.10)' }}
      />

      <div className="relative">
        <div className="mb-2 flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full" style={{ background: 'var(--sand)' }} />
          <span
            className="text-[10px] font-medium uppercase tracking-[0.18em]"
            style={{ color: 'var(--sand)' }}
          >
            {eyebrow}
          </span>
        </div>

        <h2 className="font-serif text-[26px] font-normal leading-[1.15] tracking-[-0.005em]">
          <HeadlineWithItalic headline={headline} italic={italic} />
        </h2>

        <div className="mt-[18px] flex flex-wrap gap-2">
          <button
            onClick={onReviewList}
            className="rounded-[12px] px-[18px] py-[10px] text-[13px] font-semibold tracking-[-0.01em]"
            style={{ background: 'var(--cream)', color: 'var(--forest)' }}
          >
            {primaryLabel}
          </button>
          {showPlanMeals && (
            <button
              onClick={onPlanMeals}
              className="rounded-[12px] px-4 py-[10px] text-[13px] font-medium"
              style={{ border: '1px solid rgba(255,255,255,0.35)', color: 'var(--forest-ink)' }}
            >
              Plan meals
            </button>
          )}
        </div>
      </div>
    </section>
  )
}
